import React, { useState, useEffect } from "react";
import classNames from "classnames";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import ArrowBack  from "@material-ui/icons/ArrowBack";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import List from '@material-ui/core/List';
import Link from '@material-ui/core/Link';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Checkbox from  '@material-ui/core/Checkbox';

import styles from "assets/jss/material-kit-react/views/principalPage.js";
import  "assets/css/PrincipalPage.css";

import image from "assets/img/bg7.jpg";
import { Message } from "@material-ui/icons";

import myCookies from 'universal-cookie';

import 'prevent-pull-refresh';

import axios from 'axios';
//import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { Dialog, DialogContent, FormControlLabel } from "@material-ui/core";
import { BS_ALE, myEncodeURI } from "funcs/MyFuncs";

import AddProd from "views/PrincipalPage/SelecionaProd_selecionaSabor.jsx";

const delayProcessando     = 0;
const tempoMinProcess      = 0;

const corCheckBoxRemove = '#980000';
const corCheckBoxAdiciona = '#cc0000';

const RemoveCheckbox = withStyles({
    root: {
        color: corCheckBoxRemove,
      '&$checked': {
        color: corCheckBoxRemove,
      },
      [`& label`]: {
        color: corCheckBoxRemove,
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);

const AdicionaCheckbox = withStyles({
    root: {
        color: corCheckBoxAdiciona,
      '&$checked': {
        color: corCheckBoxAdiciona,
      },
      [`& label`]: {
        color: corCheckBoxAdiciona,
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);

class PrincipalPage extends React.Component {

    arrPosItems  = [];    
    arrMenuItems = [];
    cardBody     = null;
    myMenu       = null;
    cabecalho    = null;
    dialogContentAddProd = null;

    ultElementMenu = -1;

    // Embrace React
    anchorRef = React.createRef();

    constructor(props) {
        super(props);
        // Não chame this.setState() aqui!

        let localCart = localStorage.getItem(global.ProductObj.chaveLocalStorage);
        localCart = JSON.parse(localCart);
        //load persisted cart into state if it exists
        if (!localCart) {
            localCart = [];
        }

        let myRestID = localStorage.getItem("@vmx-001/rest-id");
        if (!myRestID) {
            myRestID = "";
        }

        this.state = { 
            pesquisaTxt : global.ProductObj.pesquisaProd,
            listaGruPro: [], usr_id: 12, usr_grures: 6, scrollMarginTop: (global.ProductObj.pesquisaProd.length > 0) ? 170 : 120,
            grupos_prods: [null, null, null, null, null, null, null, null],
            nomeRest: "",
            restID: "" ,
            grupoRest: "",
            promocao: "0",
            itemAtivo: 0,
            posItemClicado: -1,
            eventClicado: -1,
            carrinhoCompra: localCart,
            restAtual: myRestID,

            marginTopStopRefresh: 100,

            alertaAddProd : false,
        };

        this.updateDimensions = this.updateDimensions.bind(this);

    }

    setScrollToTop = () => {

        setTimeout( () => {
            window.scrollTo(0, 0);
        }, 1000)
        
        
    }

    verificaMensageKG(){
        if (!global.mensagemUnidadeShowed){
            var cart = this.state.carrinhoCompra;
            var temProdutoKg = false;
    
            temProdutoKg = cart.some((produto, index) => {
                return produto.sabores.some( (sabor, index) => {
                    var saborAtual = sabor.produto;
                    return (saborAtual.unidade == "KG");
                });
            });
    
            if (temProdutoKg) {
                global.mensagemUnidadeShowed = true;
                BS_ALE(this, 'Atenção', global.txtMensagemUnidade);
            }
        }
    }

    componentDidMount(){

        var parametros = 'parresid='  + this.state.usr_id + "&parverapp=" + 23;
        this.setState({ 'erroDB' : false });

        this.updateDimensions();
        //window.addEventListener('scroll', this.updateDimensions);
        window.addEventListener('scroll', this.updateDimensions)

        try{

            this.handleLoad();

            var abreTermos = false;

            let versaoTermoAtual = localStorage.getItem(global.cod_restaurante + "versaoTermosVMX");

            versaoTermoAtual = (versaoTermoAtual) ? versaoTermoAtual : 0;

            if (global.mostraTermos){
                if (this.state.carrinhoCompra.length > 0){
                    global.mostraTermos = false;
                    abreTermos          = true;             
                }
            }               

            this.setState({
                versaoTermoAtual : versaoTermoAtual,
                infoObrigOpen: abreTermos,
            });

        }catch (err){
        //BS_ALE(this,  '', 'Não foi possível atualizar as informações, tente novamente mais tarde', [{text: 'OK', onPress: () => this.closeProgress()},],{cancelable: false},);
            this.setState({ 'erroDB' : true });
        } 
        //this.verificaAtt();
        console.log('DDDDDDD');
        this.setScrollToTop();
    }

    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.updateDimensions);
    }
    
    updateDimensions() {
        var alturaScroll = document.body.scrollHeight - window.innerHeight;
        var scrolledY    = (window.scrollY - this.state.marginTopStopRefresh);

        var alturaItems  = 0;

        this.arrPosItems.map((item, index) => {
            alturaItems += (item) ? item.clientHeight : 0;
        });

        var proporcao = (alturaItems) / (alturaScroll - this.state.marginTopStopRefresh);

        var tmpPos = 0;
        var itemAtual = 0;

        //const {bottom} = this.anchorRef.current.getBoundingClientRect();

        if (this.anchorRef.current){
            let { bottom } = this.anchorRef.current.getBoundingClientRect();
            BS_ALE(this, 'aaa', Math.floor(bottom))
        }
        

        for (var i = 0; i < this.arrPosItems.length; i++){
            var tmpItem = this.arrPosItems[i];
            tmpPos += (tmpItem) ? tmpItem.clientHeight : 0;

            if ( (scrolledY * proporcao) < ( ( ((this.cabecalho) ? tmpPos + (this.cabecalho.clientHeight) : tmpPos) + this.state.marginTopStopRefresh) - this.state.scrollMarginTop) ){
                break;
            }else{
                itemAtual = (i >= (this.ultElementMenu)) ? this.ultElementMenu : i + 1;
            }
        }        

        if (this.state.posItemClicado == -1){
            if (itemAtual !== this.state.itemAtivo) {
                this.setState({ itemAtivo: itemAtual});

                if (itemAtual > 0){
                    this.myMenu.scrollTo({left: this.arrMenuItems[itemAtual].offsetLeft - 30, behavior: 'smooth'})
                }else{
                    this.myMenu.scrollTo({left: 0, behavior: 'smooth'})
                }
            }
        }else if (scrolledY == this.state.posItemClicado){

            if (this.state.eventClicado == -1){
                if (itemAtual !== this.state.itemAtivo) {
                    this.setState({ itemAtivo: itemAtual});
                }
    
                if (itemAtual > 0){
                    this.myMenu.scrollTo({left: this.arrMenuItems[itemAtual].offsetLeft - 30, behavior: 'smooth'})
                }else{
                    this.myMenu.scrollTo({left: 0, behavior: 'smooth'})
                }
                this.setState({ 
                    posItemClicado: -1,
                });
            }else{
                this.myMenu.scrollTo({left: this.arrMenuItems[this.state.eventClicado].offsetLeft - 30, behavior: 'smooth'})
                this.setState({ 
                    itemAtivo: this.state.eventClicado,
                    posItemClicado: -1,
                    eventClicado : -1,
                });
            }
        }else{
            if (itemAtual !== this.state.itemAtivo) {
                this.setState({ itemAtivo: itemAtual});

                if (itemAtual > 0){
                    this.myMenu.scrollTo({left: this.arrMenuItems[itemAtual].offsetLeft - 30, behavior: 'smooth'})
                }else{
                    this.myMenu.scrollTo({left: 0, behavior: 'smooth'})
                }
            }
        }


    }

    atualizaPadraoDB = async (parametros, metodo, tabelaNome, arrLista) => {
        
        try {
    
            var CancelToken = axios.CancelToken;
    
            console.log('TIMEIN');
            let source = CancelToken.source();
            setTimeout(() => {
              source.cancel();
              console.log('TIMEOUT');
            }, 20000);
    
            
            await axios.post(
              global.urlServer + metodo, 
              parametros,
              {
                cancelToken: source.token,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                }
              }).then((response) => {
                var responseData = response.data;
                if (responseData.resposta == '1') {
                  arrLista = JSON.parse(JSON.stringify(responseData.registros));
                  
                  var arrFinal = [];
    
                  if (arrLista){
                    arrLista.map((prop, key) => {
                      arrFinal.push({
                        key : key, 
                        codInterno : prop.idGrupo, 
                        nome : prop.nome, 
                        precoDelivery : prop.posicao, 
                        descricao : global.urlServer + 'imgs/' + this.state.usr_grures + '/' + prop.cor + '.png',
                        image: global.urlServer + 'imgs/' + this.state.usr_grures + '/' + prop.cor + '.png',
                      });
                    });
                  }
                  
    
                  console.log(arrFinal);
                  this.setState({
                    listaGruPro: arrFinal,
                  });
                }else{
                  this.setState({
                    erroDB : true,
                  });
                }
            })
            .catch((error) =>{
              if (error == '785936'){
    
              }else if(axios.isCancel(error)){
    
              }else{
            
    
              }
            });
        } catch (err) {
          
        }    
      } 

    clickProd(item){
        alert('Hello: ' + item.nome);
    }

    scrollToItem = (index) => {
        //alert('Hello: ' + index);
        //this.arrPosItems[index].scrollIntoView({behavior: 'smooth'});

        var offsetNextScroll = 80;

        var alturaScroll = document.body.scrollHeight - window.innerHeight - this.state.scrollMarginTop;
        var scrolledY    = window.scrollY;

        var alturaItems  = 0;

        this.arrPosItems.map((item, index) => {
            alturaItems += (item) ? item.clientHeight : 0;
        });

        var proporcao = (alturaItems) / alturaScroll;

        var posicaoItem  = 0;

        this.arrPosItems.map((item, itemIndex) => {
            if (itemIndex == index){
                posicaoItem = (item) ? ( ((item.offsetTop + this.cardBody.offsetTop) - this.state.scrollMarginTop) + this.state.marginTopStopRefresh ) : 0;
            }
        });

        /*for (var i = 0; i < (index); i++){
            var tmpItem = this.arrPosItems[i];
            posicaoItem += (tmpItem) ? tmpItem.clientHeight : 0;
        }

        posicaoItem -= this.state.scrollMarginTop;
        posicaoItem += this.cabecalho.clientHeight;
        posicaoItem = posicaoItem / proporcao;
        posicaoItem += offsetNextScroll;
        posicaoItem = Math.round(posicaoItem);*/

        window.scrollTo({top: posicaoItem, behavior: 'smooth'});

        this.setState({
            posItemClicado : posicaoItem,
            eventClicado   : index,
        });
        
    }

    renderMenu = (items) => {
        const { classes } = this.props;
        var resultado = null;

        return items.map((item, index) => {

            if (item == null){
                return (
                    <div ref={(ref) => this.arrMenuItems[index] = ref} style={{marginRight: '10px', display: 'inline-block', width: '125px', height: '30px'}} className={'my-loading'}></div>
                ); // my-loading
            }

            var prodArrFinal = [];
            var primeiraCateg = true;
            item.produtos.filter(produto => (this.comparaTexto(produto.nomeProduto, this.state.pesquisaTxt) || this.comparaTexto(produto.descricao, this.state.pesquisaTxt))).map(
                filteredProduto => prodArrFinal.push(filteredProduto)
            );

            if (prodArrFinal.length > 0){
                if (index == this.state.itemAtivo){
                    return (
                        <div ref={(ref) => this.arrMenuItems[index] = ref} style={{marginRight: '10px', display: 'inline-block',}}>
                            <a onClick={() => {this.scrollToItem(index)}} style={{fontSize: '15px', fontWeight: 'bold', color: 'black'}}>{item.nome}</a>
                            <div style={{marginTop: '4px', backgroundColor: '#f00'}} className={classes.separatorMenu}></div>
                        </div>
                    );    
                }else{    
                    return (
                        <div ref={(ref) => this.arrMenuItems[index] = ref} style={{marginRight: '10px', display: 'inline-block',}}>
                            <a onClick={() => {this.scrollToItem(index)}} style={{fontSize: '15px', fontWeight: 'bold', color: 'black'}}>{item.nome}</a>
                        </div>
                    );                      
                }
                
            }else{
                return (
                    <div style={{ display: 'inline-block', }} ref={(ref) => this.arrMenuItems[index] = ref}>

                    </div>
                );
            }
            
        });
    }

    selectProd = (prod, grupoProd) => {
        
        global.ProductObj.setQtdeSabores(1, grupoProd, grupoProd.codigo, grupoProd.nome);
        global.ProductObj.setSabor(prod);
        //this.props.history.push("/selecionaprod-seleciona-sabor");
        this.setState({
            alertaAddProd : true
        });

    }

    selecionaQtdSabor = (qtdeSabore, grupoProd) => {

        global.ProductObj.setQtdeSabores(qtdeSabore, grupoProd, grupoProd.codigo, grupoProd.nome);
        
        this.setState({
            alertaAddProd : true
        });

    }

    renderQtdeSabores = (grupoProd) => {
        const { classes } = this.props;

        return (
            <div>
                <div onClick={(e) => this.selecionaQtdSabor(1, grupoProd)}>
                    <div style={{display: 'flex', flexDirection: 'row', marginTop: '15px'}}>
                        <div>
                            <div>
                                <text style={{fontSize:'18px', fontWeight:'bold'}}>{grupoProd.nome} - 1 Sabor</text>
                            </div>
                        </div>
                    </div>
                    <div style={{marginTop: '10px'}} className={classes.separator}></div>            
                </div>
                <div onClick={(e) => this.selecionaQtdSabor(2, grupoProd)}>
                    <div style={{display: 'flex', flexDirection: 'row', marginTop: '15px'}}>
                        <div>
                            <div>
                                <text style={{fontSize:'18px', fontWeight:'bold'}}>{grupoProd.nome} - 2 Sabores</text>
                            </div>
                        </div>
                    </div>
                    <div style={{marginTop: '10px'}} className={classes.separator}></div>            
                </div>
            </div>
        );
    }

    renderImageGruProd = (cod_grurest, imagem) => {
        if (imagem){
            if (imagem.length > 0){
                return (
                    <img src={global.siteurl + "imgs/" + cod_grurest + "/" + imagem + ".png"} style={{width: '200px', margin: 'auto'}} onError={(e)=>{
                        e.target.onerror = null; 
                        e.target.style.visibility = 'hidden';
                        e.target.style.display = 'none' ;
                    }}></img>
                );
            }
        }
    }

    renderImageProd = (cod_restaurante, imagem) => {
        if (imagem){
            if (imagem.length > 0){
                return (
                    <div style={{flex: 1, minWidth: '130px', display: "flex", justifyContent: "flex-end"}}>
                        <img src={global.siteurl + "rests/" + cod_restaurante + "/imgs/prods/" + imagem + ".png"} style={{width: '105px', height: "70px", margin: 'auto 0px'}} onError={(e)=>{
                                e.target.onerror = null; 
                                e.target.style.visibility = 'hidden';
                            }}></img>
                    </div>
                );
            }
        }
    }

    renderDescricao = (descricao) => {

        if ((descricao) && (descricao != '')) {
            return (
                <div>
                    <text style={{display: 'inline-block', fontSize:'13px', lineHeight: '18px'}}>{descricao}</text>
                </div>  
            );
        }

    }

    renderProds = (grupoProd, prodArrFinal) => {
        const { classes } = this.props;

        return prodArrFinal.map((prod, index) => {
            return (
                <div style={{cursor: 'pointer'}} onClick={() => { this.selectProd(prod, grupoProd) }}>
                    <div style={{display: 'flex', flexDirection: 'row', marginTop: '15px'}}>
                        <div>
                            <div>
                                <text style={{fontSize:'16px', fontWeight:'bold'}}>{prod.nomeProduto + ( (global.mostraUnidade) ? ' (' + prod.unidade + ')' : '' )}</text>
                            </div>
                            {this.renderDescricao(prod.descricao)}
                            <div>
                                <text style={{fontSize:'16px', fontWeight:'bold', color: '#777'}}>R$ {prod.preco.replace('.', ',')}</text>
                            </div>                  
                        </div>
                        {this.renderImageProd(global.cod_restaurante, prod.imagem)}
                    </div>    
                    <div style={{marginTop: '10px'}} className={classes.separator}></div>            
                </div>
            );
        });
    }

    verificaGrupoProd = ( grupoProd, prodArrFinal ) => {
        if (grupoProd.misto > 1){
            return this.renderQtdeSabores(grupoProd);
        }else{
            return this.renderProds(grupoProd, prodArrFinal);
        }
    }
    
    renderLista = (items) => {
        const { classes } = this.props;
        var resultado = null;

        return items.map((item, index) => {

            if (item == null){
                return (
                    <div className={"my-loading"}  ref={(ref) => this.arrPosItems[index] = ref} style={{ scrollMarginTop: (this.state.scrollMarginTop + "px"), maxWidth: '100%', marginLeft: '20px', marginRight: '20px', marginBottom: '30px', height: '150px'}}></div>
                ); // my-loading
            }

            var prodArrFinal = [];
            var primeiraCateg = true;
            item.produtos.filter(produto => (this.comparaTexto(produto.nomeProduto, this.state.pesquisaTxt) || this.comparaTexto(produto.descricao, this.state.pesquisaTxt))).map(
                filteredProduto => prodArrFinal.push(filteredProduto)
            );

            if (prodArrFinal.length > 0){
                this.ultElementMenu = index;
                return (
                    <div ref={(ref) => this.arrPosItems[index] = ref} style={{ scrollMarginTop: (this.state.scrollMarginTop + "px"), maxWidth: '100%', marginLeft: '20px', marginRight: '20px', marginBottom: '30px'}}>
                        <div style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
                            {this.renderImageGruProd(global.cod_grurest, item.imagem)}
                            <text style={{margin: '7px auto', fontSize: '22px', color: '#a30000', fontWeight: 'bold'}} >{item.nome}</text>
                            <div style={{height: '2px'}} className={classes.separator}></div>
                        </div>                
                        <div>
                            {this.verificaGrupoProd(item, prodArrFinal)}
                        </div>
                    </div>
                );
            }else{
                return (
                    <div ref={(ref) => this.arrPosItems[index] = ref} >
                        
                    </div>
                );
            }

            /*return (
                <ListItem style={{scrollMarginTop: this.state.scrollMarginTop, }} key={index} ref={(ref) => this.arrPosItems.push(ref)} onClick={() => this.clickProd(item)} alignItems="flex-start">
                    <ListItemAvatar> 
                        <Avatar variant="square" imgProps={{width: '100%', height: 'unset'}} src={item.image} classes={{ img: classes.myAvatarImg }} className={classes.myImgProds} />
                    </ListItemAvatar>
                    <ListItemText
                        primary={item.nome}
                        secondary={
                            <React.Fragment>
                                {this.renderProds(item)}
                            </React.Fragment>
                        }
                    />
                </ListItem>
            );*/
        });
    }

    pesquisaLista = (value) => {
        global.ProductObj.pesquisaProd = value;
        this.setState({pesquisaTxt: value}, () => {
            this.updateDimensions();
        });
    }

    abrePesquisa = (pesquisaAberta) => {
        if (pesquisaAberta){
            this.setState({
                scrollMarginTop: 170
            });
        }else{
            this.setState({
                scrollMarginTop: 120
            });
        }        
    }

    comparaTexto(val1, val2){

        var arrPalavras = val2.split(' ');
    
        var resultado = true;
        arrPalavras.map((palavra, index) => {
          if (!this.trataTexto(val1).includes(this.trataTexto(palavra))){
            resultado = false;
          }
        });
    
        return resultado;
    }

    trataTexto(val){
        return (
            val.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        );
    }

    handleLoad() {
        var menuItems = [];
    
        try {
    
          var CancelToken = axios.CancelToken;
    
          console.log('TIMEIN');
          let source = CancelToken.source();
          setTimeout(() => {
            source.cancel();
            console.log('TIMEOUT');
          }, 20000);
    
          var parametros = 'parresid=' + global.cod_restaurante;
         
          axios.post(
            global.siteurl + 'produtos_lista.php', 
            parametros,
            {
                cancelToken: source.token,
                headers: {
                   'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                },
                withCredentials: true
            }).then((response) => {
              var responseData = response.data;
              console.log('LIIIISTAAA ----- ' + responseData);
              // 
              if (responseData.resposta == '1') {
                var arrLista = JSON.parse(JSON.stringify(responseData.registros));
                var arrFinal = [];

                global.restAberto = (responseData.restaurante.aberto) ? responseData.restaurante.aberto : "0";
    
                if (responseData.promocao == '1'){
    
                  var arrProdPromo = [];
    
                  for (var index = 0; index < responseData.registros.length; index++){
                    if (index > 1){
                      for (var i = 0; i < responseData.registros[index].produtos.length; i++){
                        if ((responseData.registros[index].produtos[i].promo == "1") && ( this.comparaTexto(responseData.registros[index].produtos[i].nomeProduto, this.state.pesquisaTxt) || this.comparaTexto(responseData.registros[index].produtos[i].descricao, this.state.pesquisaTxt ) ) ){
                          arrProdPromo.push( responseData.registros[index].produtos[i] );
                        }
                      };
                    }  
                  }
    
                  arrFinal.push({
                    nome : "Promoções",
                    imagem : "",
                    info : "",
                    produtos : arrProdPromo,
                  });
                }
    
                arrLista.map((prop, key) => {
    
                  arrFinal.push({
                    nome : prop.nome,
                    misto : prop.misto,
                    imagem : prop.cor,
                    info : prop.info,
                    codigo: prop.idGrupo,
                    produtos : prop.produtos,
                    grupoAdics : prop.grupoAdics,
                  });
                  
                });
                
                document.title = "Web App - " + responseData.restaurante.nome;
                
                this.setState({
                  grupos_prods: arrFinal,
                  nomeRest: responseData.restaurante.nome,
                  restID: responseData.restaurante.cod_rest,
                  grupoRest: responseData.restaurante.grupo_rest,
                  promocao: responseData.promocao,
                }, () => {
                    const cookies = new myCookies();

                    var enviarCookie = (cookies.get(global.cod_restaurante + '_contaAccess') != 'TALION');

                    if (enviarCookie){

                        var now = new Date();
                        var time = now.getTime();
                        var maxAge     = 60*60*2;
                        var expireTime = time + maxAge;

                        var expires = (new Date(expireTime));

                        cookies.set(global.cod_restaurante + '_contaAccess', 'TALION', { path: '/', expires: expires, maxAge: maxAge });
                        
                        var CancelToken = axios.CancelToken;

                        const {log_senha, log_usu} = this.state;
                    
                        var parametros = 
                        "parres="    + global.cod_restaurante;

                        let source = CancelToken.source();
                        setTimeout(() => {
                            source.cancel();                            
                        }, global.timeOutTimer);
                        
                        axios.post(
                            global.siteurl + 'count_access.php', 
                            parametros,
                            {
                            cancelToken: source.token,
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                            },
                            withCredentials: true,
                        }).then((response) => {
                            
                        })
                        .catch((error) =>{
                            
                            if(axios.isCancel(error)){
                
                                //BS_ALE(this,  'Atenção', 'Não foi possível efetuar a solicitação, verifique sua conexão e tente novamente. \nCOD 029');
                        
                            }
                            else{
                                
                                console.log('ERRRR - ' + JSON.stringify(error))
                                
                            }
                        });
                        

                    }
                    
                });
              }else{
                  
              }
          })
          .catch((error) =>{

            if(axios.isCancel(error)){
            }
            else{
            }
          });
        } catch (err) {
          
        }  
    
    
        
      }

    handleChangeRegulamentoAceito = (e) => {
        this.setState({
            regulamentoAceita : !(this.state.regulamentoAceita)
        });
    }

    handleCloseAddProd = () => {

        let localCart = localStorage.getItem(global.ProductObj.chaveLocalStorage);
        localCart = JSON.parse(localCart);
        //load persisted cart into state if it exists
        if (!localCart) {
            localCart = [];
        }

        this.setState({
            alertaAddProd : false,
            carrinhoCompra: localCart
        })
    }

    handleDialogScroll = () => {
        var teste = this.dialogContentAddProd.scrollTop;

        this.setState({
            dialogScrollPos : teste
        })
    }

    renderDialogAddProd = () => {

        const { classes } = this.props;

        const appBarClasses = classNames({
            [classes.appBar]: true,
            [classes.color]: '#000',
            [classes.absolute]: 'absolute',
            [classes.fixed]: 'fixed'
          });

        return (

            <Dialog
                open={this.state.alertaAddProd}
                onClose={this.handleCloseAddProd}
                disableBackdropClick 
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                classes={{ container: classes.rootNoPadding, paper: classes.paperFullSize }}
                style={{maxWidth: '720px', margin: '0 auto 0 auto'}}
            >
                <DialogContent onScroll={() => this.handleDialogScroll()} ref={(ref) => {this.dialogContentAddProd = ref}} style={{width: '100%', height: '100%', padding: '0px'}}>
                    <AddProd 
                        vmxale={this.props.vmxale}
                        scrollFunction={() => {
                            this.dialogContentAddProd.scrollTo({top: 0, behavior: 'auto'});
                        }} 
                        posicaoScroll={this.state.dialogScrollPos}
                        closeFunc={() => {
                            this.handleCloseAddProd()
                        }}
                    />
                </DialogContent>
            </Dialog>

        );
    }

    renderDialogInfoObrig = () => {

        const { classes } = this.props;

        const appBarClasses = classNames({
            [classes.appBar]: true,
            [classes.color]: '#000',
            [classes.absolute]: 'absolute',
            [classes.fixed]: 'fixed'
          });

        var versaoTermoAtual = this.state.versaoTermoAtual

        return(
          <Dialog
              open={(this.state.infoObrigOpen && (global.infoObrig != '') && ( (versaoTermoAtual != global.infoObrigVer) || (global.infoObrigVer == 0) ))}
              onClose={() => {
                this.setState({
                    infoObrigOpen: false
                });
              }}
              disableBackdropClick 
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              classes={{ container: classes.root, paper: classes.paperFullSize }}
              style={{maxWidth: '720px', margin: '0 auto 0 auto'}}
          >
              <div className={appBarClasses} style={{display: 'flex', flexDirection: 'column', backgroundColor: "#000", marginBottom: '0px'}}>
                <div style={{height: '50px', width: '100%', display: 'flex', position: 'relative'}}>
                  <text style={{fontSize: '18px', fontWeight: 'bold', color: '#fff', margin: 'auto auto auto auto'}}>{global.infoObrigTitulo}</text>
                </div>                    
              </div>
              <DialogContent style={{width: '100%', height: '100%',}}>
                  <div style={{display: 'flex', flexDirection: 'column', marginTop: '0px', marginBottom: '0px'}}>
                      <div>
                        <img src={global.siteurl + "rests/" + global.cod_restaurante + "/imgs/rest/path.php?t=restimg"} style={{width: '80%', margin: '10px 10% 10px 10%'}}></img>
                        <div dangerouslySetInnerHTML={{ __html: global.infoObrig }} />
                      </div>
                  </div>
                    <FormControlLabel
                        control={<AdicionaCheckbox checked={(this.state.regulamentoAceita >= 1) ? true : false} value={"1"} onChange={this.handleChangeRegulamentoAceito} name="checkedG" />}
                        label={"Concordo com os termos acima"} style={{color: corCheckBoxAdiciona, width: '100%',}}
                    />
                    <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={() => {
                                if (this.state.regulamentoAceita){

                                    //global.infoObrigVer

                                    localStorage.setItem(global.cod_restaurante + "versaoTermosVMX", global.infoObrigVer);
                                    this.setState({
                                        infoObrigOpen: false
                                    });
                                }                                
                            }}
                            style={{backgroundColor: (this.state.regulamentoAceita) ? '#3496eb' : '#ccc'}}
                        >
                        { (this.state.regulamentoAceita) ? 'Continuar' : 'Concorde para prosseguir'}
                    </Button>
              </DialogContent>
          </Dialog>
        );
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.myBody} style={{offset: '100px'}} >
                <div className={classes.container}>
                    <Card>
                        <div className={classes.form}>
                            <CardHeader color="primary" className={classes.cardHeader} style={{display: 'flex', marginTop: '0px'}}>
                                <img ref={(ref) => {this.cabecalho = ref}}  src={global.siteurl + "rests/" + global.cod_restaurante + "/imgs/rest/path.php?t=logo"} style={{width: '100%', height: "100%", objectFit: 'contain'}}></img>
                            </CardHeader>
                            <Header context={this} searchValue={(this.state.pesquisaTxt)} searchClick={(e) => this.abrePesquisa(e)} searchFunc={(e) => this.pesquisaLista(e)} leftLinks={
                                <div ref={(ref) => this.myMenu = ref} style={{ whiteSpace: 'nowrap', overflowX: 'scroll'}}>
                                    <div style={{width: 'max-content', whiteSpace: 'nowrap', flexDirection: 'column', marginTop: '12px', marginBottom: '12px', }} className={""}>
                                        {this.renderMenu(this.state.grupos_prods)}
                                    </div>                                    
                                </div>
                            } />
                            <CardBody>
                                <List ref={(ref) => this.cardBody = ref} className={classes.root}>
                                    <List className={classes.root}>{this.renderLista(this.state.grupos_prods)}</List>   
                                </List>
                            </CardBody>
                        </div>                
                    </Card>
                </div>
                {this.renderDialogInfoObrig()}
                {this.renderDialogAddProd()}
                <Footer ref={this.anchorRef}  qtdeTiposProds={this.state.carrinhoCompra.length} whiteFont rotaAtual={this.props.location} history={this.props.history} />
            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(PrincipalPage); ;
